var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminatePaperLeftMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 191,
    viewBox: "0 0 157 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53979 219.907L23.0092 215.597L52.0086 207.517L81.0079 199.436L110.009 191.357",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18896 213.305L21.4502 209.5L50.7626 202.639L80.073 195.779L109.385 188.918",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27417 206.558L20.1471 203.344L49.7193 197.715L79.2916 192.085L108.866 186.454",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85669 199.681L19.1061 197.139L48.8849 192.749L78.6659 188.361L108.449 183.973",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999023 192.714L18.3263 190.897L48.2626 187.757L78.199 184.617L108.135 181.476",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.755859 185.697L17.8068 184.627L47.8456 182.74L77.8862 180.856L107.929 178.969",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17334 178.683L17.5471 178.34L47.637 177.711L77.7309 177.082L107.825 176.453",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09375 171.729L17.5469 172.051L47.6367 172.68L77.7307 173.309L107.825 173.938",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54834 164.869L17.8066 165.765L47.8453 167.652L77.886 169.538L107.929 171.425",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70874 158.172L18.3261 159.495L48.2625 162.637L78.1989 165.775L108.135 168.916",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84741 151.742L19.1058 153.255L48.8847 157.642L78.6656 162.03L108.449 166.42",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3831 145.76L20.147 147.05L49.7192 152.677L79.2915 158.308L108.866 163.938",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9939 140.551L21.4506 140.892L50.763 147.754L80.0733 154.613L109.386 161.473",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6135 136.634L52.0086 142.874L81.0079 150.956L110.009 159.035",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.407 134.469L53.4633 138.054L82.1005 147.34L110.736 156.626",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3418 133.38L83.3428 143.775L111.565 154.25",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3994 132.151L84.7337 140.261L112.493 151.907",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7812 130.477L86.2743 136.815L113.518 149.608",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3975 128.446L87.9583 133.434L114.642 147.354",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8574 126.136L89.7809 130.123L115.857 145.149",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5342 123.598L91.7432 126.895L117.164 142.995",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6458 120.845L93.8379 123.753L118.563 140.902",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3367 117.879L96.0643 120.701L120.045 138.864",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7014 114.675L98.4169 117.742L121.614 136.894",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8005 111.21L100.888 114.884L123.261 134.989",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6792 107.444L103.479 112.134L124.986 133.154",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.363 103.308L106.182 109.491L126.789 131.393",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M128.662 129.709L108.99 106.966L101.698 98.535C101.698 98.533 101.698 98.533 101.698 98.533",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M103.086 93.4551L111.904 104.558L130.606 128.106",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.582 88.0766L114.918 102.271L132.613 126.581",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.212 82.3768L118.024 100.118L134.684 125.146",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.011 76.3325L121.213 98.0918L136.814 123.792",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M110.015 69.9218L124.493 96.2036L138.996 122.534",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M112.268 63.1391L114.455 67.5371L127.842 94.4519L141.231 121.367",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M114.824 55.9864L119.02 65.3909L131.265 92.8427L143.514 120.294",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M117.745 48.5056L123.67 63.4413L134.755 91.3811L145.84 119.321",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.103 40.7772L128.398 61.6871L138.301 90.0658L148.203 118.445",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M124.971 32.9473L133.198 60.1357L141.9 88.9024L150.603 117.667",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M129.426 25.2373L130.572 29.6843L138.058 58.7858L145.546 87.8915L153.032 116.991",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M134.518 17.9643L136.711 28.257L142.97 57.6443L149.228 87.0317L155.489 116.421",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M140.267 11.5189L142.904 27.0855L147.925 56.7077L152.946 86.3299L157.967 115.954",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M146.628 6.3021L149.144 26.1768L152.917 55.9807L156.69 85.7846L160.463 115.591",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M153.49 2.66353L155.413 25.5274L157.932 55.462L160.45 85.3945L162.971 115.329",
    stroke: "#3571D6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminatePaperLeftMobile);
export default __webpack_public_path__ + "static/media/eliminate-paper-left-mobile.f0ffe15ed36405d123843d32c3ad06f0.svg";
export { ForwardRef as ReactComponent };